import { TranslationKey } from '../functions/i18n';

export const pt: Record<TranslationKey, string> = {
  'nav.records': 'Registros',
  'nav.meds': 'Meds.',
  'nav.guide': 'Biblioteca',
  'nav.options': 'Lembretes',
  'topbar.welcome': 'Bem-vindo',
  'splash.tagline': 'Master Pet Health. Conquer the Fellowship.',
  'records.tab.todayEntry': 'Diário',
  'records.tab.allCards': 'Histórico',
  'records.tab.worksheet': 'Dados',
  'meds.title': 'Medicamentos',
  'meds.empty': 'Nenhum medicamento adicionado',
  'trends.title': 'Trends',
  'trends.noDataTitle': 'Sem dados ainda',
  'trends.noDataBody': 'Comece a registrar seus sinais vitais na aba Cartões para ver tendências aqui.',
  'trends.moreDataNeeded': 'Mais dados necessários',
  'trends.moreDataNeededBody': 'Precisamos de pelo menos 3 dias de dados registrados para gerar tendências. Continue assim!',
  'trends.avgWeight': 'Peso médio',
  'trends.avgHeartRate': 'Avg Heart Rate',
  'trends.avgRespRate': 'Freq. respiratória méd.',
  'trends.avgMucousMembrane': 'Mucosas médias',
  'trends.avgWaterIntake': 'Ingestão média de água',
  'trends.avgTemperature': 'Temperatura média',
  'trends.weightTrend': 'Weight Trend',
  'trends.heartRateTrend': 'Heart Rate Trend',
  'trends.respRateTrend': 'Respiratory Rate Trend',
  'trends.mucousMembraneTrend': 'Distribuição das mucosas',
  'trends.fluidIntakeTrend': 'Water Intake Trend',
  'trends.foodIntakeTrend': 'Tendência ingestão alimentar',
  'trends.avgFoodIntake': 'Ingestão média de alimento',
  'trends.day': 'dia',
  'trends.days': 'dias',
  'trends.tooltipWeight': 'Peso',
  'trends.tooltipFluid': 'Ingestão de líquidos',
  'trends.tooltipFood': 'Ingestão alimentar',
  'trends.tooltipHeartRate': 'Heart Rate',
  'trends.tooltipRespRate': 'Resp. Rate',
  'trends.tooltipMucousMembrane': 'Mucosas',
  'trends.fluidBalanceTrend': 'Tendência do balanço hídrico',
  'trends.tempTrend': 'Tendência da temperatura',
  'trends.moodTrend': 'Tendência do humor',
  'trends.mucousMembrane.pink': 'Rosas',
  'trends.mucousMembrane.red': 'Vermelhas',
  'trends.mucousMembrane.blue': 'Azuladas',
  'trends.mucousMembrane.white': 'Brancas',
  'trends.noMucousMembraneData': 'Ainda não há registos de mucosas neste intervalo.',
  'trends.moodLabel.terrible': 'Péssimo',
  'trends.moodLabel.notGreat': 'Não muito bem',
  'trends.moodLabel.okay': 'Razoável',
  'trends.moodLabel.good': 'Bom',
  'trends.moodLabel.great': 'Ótimo',
  'trends.tooltipFluidBalance': 'Balanço hídrico (Entrada − Saída)',
  'trends.tooltipTemp': 'Temperatura',
  'trends.tooltipMood': 'Humor',
  'trends.customise': 'Personalizar',
  'trends.resetLayout': 'Redefinir layout',
  'trends.viewPlans': 'Ver planos',
  'trends.trendsLockedTitle': 'As tendências são uma funcionalidade paga',
  'trends.trendsLockedBody': 'Subscreva o KodaCare para acompanhar o seu peso, pressão arterial, ingestão de líquidos e muito mais ao longo do tempo.',
  'trends.lifetimeLockedTitle': 'Funcionalidade Lifetime',
  'trends.lifetimeLockedBody': 'Atualize para o plano Lifetime para desbloquear tendências de frequência respiratória, mucosas e temperatura — mais um layout de gráficos totalmente personalizável.',
  'guide.digestLockedTitle': 'Digest Mensal Renal',
  'guide.digestLockedBody': 'Atualize para o plano Lifetime para receber a nossa newsletter mensal selecionada — as notícias mais relevantes em tecnologia renal, investigação farmacológica e histórias da comunidade transplantada.',
  'options.title': 'Notificações',
  'options.appPreferences': 'Preferências do app',
  'options.language': 'Idioma',
  'options.units': 'Unidades',
  'options.metric': 'Métrico',
  'options.imperial': 'Imperial',
  'options.dateFormat': 'Formato de data',
  'options.timeFormat': 'Formato de hora',
  'options.transplant': 'Transplante',
  'options.editProfile': 'Editar perfil',
  'options.saveToHomeScreen': 'Instalar aplicação',
  'options.logOut': 'Sair',
  'options.fullName': 'Nome completo',
  'options.profession': 'Profissão',
  'options.professionPlaceholder': 'ex. Enfermeiro, Cirurgião',
  'options.emailAddress': 'Endereço de e-mail',
  'options.emailCannotChange': 'O e-mail não pode ser alterado.',
  'options.transplantDate': 'Data do transplante',
  'options.changePassword': 'Alterar senha',
  'options.deleteAccount': 'Excluir conta',
  'options.cancel': 'Cancelar',
  'options.saveChanges': 'Salvar alterações',
  'login.email': 'E-mail',
  'login.password': 'Senha',
  'login.forgotPassword': 'Esqueceu a senha?',
  'login.signIn': 'Entrar',
  'login.continueWithGoogle': 'Continuar com Google',
  'login.noAccount': 'Não tem uma conta?',
  'login.register': 'Cadastrar',
  'login.or': 'ou',
  'login.rememberMe': 'Lembrar-me por 30 dias',
  'forgot.title': 'Redefinir sua senha',
  'forgot.subtitle': 'Digite seu e-mail e enviaremos um link para redefinir sua senha.',
  'forgot.checkInboxTitle': 'Verifique sua caixa de entrada',
  'forgot.checkInboxBody': 'Enviamos um link de redefinição de senha para {email}. Siga o link para escolher uma nova senha.',
  'forgot.spamHint': 'Não recebeu? Verifique sua pasta de spam ou lixo eletrônico.',
  'forgot.backToSignIn': 'Voltar para entrar',
  'forgot.sendResetLink': 'Enviar link de redefinição',
  'forgot.rememberPassword': 'Lembrou sua senha?',
  'forgot.legal': 'Ao entrar, você concorda com nossos Termos de Serviço e Política de Privacidade.',
  'forgot.errorNoAccount': 'Nenhuma conta encontrada com esse endereço de e-mail.',
  'forgot.errorNetwork': 'Erro de rede. Verifique sua conexão e tente novamente.',
  'forgot.errorGeneric': 'Não foi possível enviar o e-mail de redefinição. Tente novamente.',
  'verify.title': 'Verifique seu e-mail',
  'verify.subtitle': 'Enviamos um link de verificação para {email}. Clique no link desse e-mail e depois volte para entrar.',
  'verify.errorResend': 'Não foi possível reenviar o e-mail. Tente novamente em instantes.',
  'verify.resent': 'E-mail de verificação reenviado — verifique sua caixa de entrada.',
  'verify.emailSent': 'E-mail enviado ✓',
  'verify.resend': 'Reenviar e-mail de verificação',
  'verify.backToSignIn': 'Voltar para entrar',
  'verify.spamHint': 'Não recebeu? Verifique sua pasta de spam ou lixo eletrônico.',
  'authAction.loading': 'Validando seu link…',
  'authAction.error.missingInfo': 'Este link de confirmação está sem informações obrigatórias.',
  'authAction.error.unsupportedMode': 'Este tipo de ação ainda não é suportado nesta página.',
  'authAction.error.expired': 'Este link expirou. Solicite um novo.',
  'authAction.error.invalid': 'Este link é inválido ou já foi usado.',
  'authAction.error.userDisabled': 'Esta conta está desativada.',
  'authAction.error.userNotFound': 'Nenhuma conta foi encontrada para este link.',
  'authAction.error.weakPassword': 'Sua nova senha está fraca demais. Escolha uma senha mais forte.',
  'authAction.error.generic': 'Não foi possível processar este link. Solicite um novo e tente novamente.',
  'authAction.error.resetInvalid': 'Este link de redefinição é inválido. Solicite um novo.',
  'authAction.error.passwordMin': 'A senha deve ter pelo menos 8 caracteres.',
  'authAction.error.passwordMismatch': 'As senhas não coincidem.',
  'authAction.verifySuccessTitle': 'E-mail confirmado',
  'authAction.verifySuccessBody': 'Seu e-mail foi verificado. Você pode entrar para continuar.',
  'authAction.recoverSuccessTitle': 'E-mail restaurado',
  'authAction.recoverSuccessBody': 'A alteração de e-mail foi revertida com sucesso. Entre novamente.',
  'authAction.continue': 'Continuar',
  'authAction.goToSignIn': 'Ir para entrar',
  'authAction.resetTitle': 'Definir nova senha',
  'authAction.resetBody': 'Redefinindo senha para {email}',
  'authAction.newPassword': 'Nova senha',
  'authAction.confirmNewPassword': 'Confirmar nova senha',
  'authAction.updatePassword': 'Atualizar senha',
  'authAction.resetSuccessTitle': 'Senha atualizada',
  'authAction.resetSuccessBody': 'Sua senha foi redefinida com sucesso.',
  'authAction.signIn': 'Entrar',
  'authAction.linkUnavailableTitle': 'Link indisponível',
  'authAction.requestNewResetLink': 'Solicitar novo link de redefinição',
  'authAction.backToSignIn': 'Voltar para entrar',
  'register.title': 'Crie sua conta',
  'register.fullName': 'Nome completo',
  'register.operationDate': 'Data do transplante / operação',
  'register.email': 'E-mail',
  'register.password': 'Senha',
  'register.confirmPassword': 'Confirmar senha',
  'register.createAccount': 'Criar conta',
  'register.haveAccount': 'Já tem uma conta?',
  'register.signIn': 'Entrar',
  'guide.comingSoon': 'Em breve',
  'guide.motivation': 'Você consegue! Voltando mais forte do que nunca.',
  // Records page
  'records.todaysOverview': 'Resumo de hoje',
  'records.selectedDayOverview': 'Resumo do dia selecionado',
  'records.weight': 'Peso',
  'records.fluids': 'Ingestão',
  'records.fluidIntake': 'Ingestão de líquidos',
  'records.foodIntake': 'Ingestão de alimentos',
  'records.urineOutput': 'Produção de urina',
  'records.saveWeight': 'Salvar peso',
  'records.undoWeight': 'Desfazer peso',
  'records.weightRecorded': 'Peso registrado',
  'records.weightRecordedToday': 'Peso registrado hoje',
  'records.add': 'Adicionar',
  'records.total': 'total',
  'records.morningVitals': 'Sinais vitais da manhã',
  'records.afternoonVitals': 'Sinais vitais da tarde',
  'records.morningVitalsRecorded': 'Sinais vitais da manhã registrados',
  'records.afternoonVitalsRecorded': 'Sinais vitais da tarde registrados',
  'records.saveVitals': 'Salvar sinais vitais',
  'records.resetTodaysData': 'Redefinir dados de hoje',
  'records.resetConfirmMessage': 'Todos os dados de hoje serão excluídos. Isso não pode ser desfeito.',
  'records.dailyLimitReached': 'Limite diário atingido (9999ml)',
  'records.newEntry': 'Nova entrada',
  'records.addNewEntry': 'Adicionar nova entrada',
  'records.saveEntry': 'Salvar entrada',
  'records.cancel': 'Cancelar',
  'records.date': 'Data',
  'records.morning': 'Manhã',
  'records.afternoon': 'Tarde',
  'records.daily': 'Diário',
  'records.bpSystolic': 'PA sistólica',
  'records.bpDiastolic': 'PA diastólica',
  'records.pulse': 'Pulso',
  'records.temp': 'Temp.',
  'records.downloadCsvFor': 'Baixar CSV para:',
  'records.thisWeek': 'Esta semana',
  'records.thisMonth': 'Este mês',
  'records.thisYear': 'Este ano',
  'records.shareDataTitle': 'Compartilhar dados com o médico',
  'records.dataCopiedToClipboard': 'Dados copiados para a área de transferência! Você pode colá-los em um e-mail ou mensagem.',
  'records.noLogEntriesYet': 'Nenhuma entrada ainda',
  'records.fillAtLeastOneField': 'Por favor, preencha pelo menos um campo',
  'records.fluid': 'Líquido',
  'records.amBp': 'PA manhã',
  'records.amPulse': 'Pulso manhã',
  'records.amTemp': 'Temp. manhã',
  'records.pmBp': 'PA tarde',
  'records.pmPulse': 'Pulso tarde',
  'records.pmTemp': 'Temp. tarde',
  'records.vitals': 'Sinais vitais',
  'records.vitalsTime': 'Vitais:',
  'records.filterBy': 'Filtrar por',
  'records.week': 'Semana',
  'records.month': 'Mês',
  'records.year': 'Ano',
  'records.entry': 'entrada',
  'records.entries': 'entradas',
  'records.today': 'Hoje',
  'records.fluidIn': 'Líquido entrada',
  'records.deleteLogEntry': 'Excluir esta entrada?',
  'records.undoWeightEntry': 'Desfazer entrada de peso',
  'records.undoLastFluidEntry': 'Desfazer última entrada de líquido',
  'records.undoLastUrineEntry': 'Desfazer última entrada de urina',
  'records.toolbar.addNote': '+ Adicionar nota',
  'records.toolbar.editNote': 'Editar nota',
  'records.toolbar.intake': 'Ingestão',
  'records.toolbar.saveNote': 'Guardar nota',
  'records.toolbar.updateNote': 'Atualizar nota',  'records.toolbar.notesPlaceholder': 'O que registar — tosse ou espirros, stress devido a eventos.\nou\nAlterações em — secreções, sono, apetite, ingestão de água.',
  'records.toolbar.add': 'Adicionar',
  'records.toolbar.save': 'Guardar',
  'records.undoMorningVitals': 'Desfazer vitais da manhã',
  'records.undoAfternoonVitals': 'Desfazer vitais da tarde',
  'records.amount': 'Quantidade',
  'records.tab.documents': 'Cofre',
  'records.documentsTitle': 'Cofre de documentos',
  'records.documentsSubtitle': 'Guarde análises, exames e cartas médicas num único lugar seguro.',
  'records.searchDocuments': 'Pesquisar documentos…',
  'records.uploadDocument': 'Carregar ficheiro',
  'records.takePhoto': 'Tirar foto',
  'records.maxFilesReached': 'Limite de ficheiros atingido para esta conta.',
  'records.categoryAll': 'Todos',
  'records.bucketLabs': 'Análises',
  'records.bucketScans': 'Exames',
  'records.bucketLetters': 'Cartas do nefrologista',
  'records.bucketDischarge': 'Papeis de alta',
  'records.bucketPrescriptions': 'Receitas',
  'records.bucketOther': 'Outro',
  'records.noDocumentsYet': 'Ainda não há documentos',
  'records.titleOptional': 'Título (opcional)',
  'records.noteOptional': 'Nota (opcional)',
  'records.documentDate': 'Data do documento',
  'records.uploading': 'A carregar…',
  'records.openFile': 'Abrir',
  'records.deleteFile': 'Eliminar',
  'records.deleteFileConfirm': 'Eliminar este ficheiro do cofre?',
  'records.dateAlreadyHasEntry': 'Esta data já tem uma entrada. Use o botão editar na tabela.',
  'records.deleteEntry': 'Excluir entrada',
  'records.deleteEntryConfirm': 'Tem certeza de que deseja excluir todos os dados desta data?',
  'records.editEntry': 'Editar entrada',
  'records.observations': 'Observações',
  'records.howAreYouFeeling': 'Como se sente hoje?',
  'records.observationsPlaceholder': 'O que registar — tosse ou espirros, stress devido a eventos.\nou\nAlterações em — secreções, sono, apetite, ingestão de água.',
  'records.saveObservations': 'Guardar observações',
  'records.observationsRecorded': 'Observações guardadas',
  'records.undoObservations': 'Desfazer observações',
  'records.moodTerribleLabel': 'Terrível',
  'records.moodBadLabel': 'Não muito bem',
  'records.moodOkayLabel': 'Razoável',
  'records.moodGoodLabel': 'Bem',
  'records.moodGreatLabel': 'Muito bem',
  'records.noObservations': 'Sem observações',
  'records.mood': 'Humor',
  // Notification Center
  'notifications.title': 'Todos os lembretes',
  'notifications.allReminders': 'Todos os lembretes',
  'notifications.storageNote': 'Os últimos 5 dias de lembretes são exibidos.',
  'notifications.new': 'novo',
  'notifications.markAllRead': 'Marcar tudo como lido',
  'notifications.allCaughtUp': 'Tudo em dia!',
  'notifications.clearAll': 'Limpar tudo',
  'notifications.clearAllConfirm': 'Toque novamente para limpar tudo',
  // Delete Confirm Modal
  'deleteConfirm.defaultTitle': 'Excluir este item?',
  'deleteConfirm.cancel': 'Cancelar',
  'deleteConfirm.delete': 'Excluir',
  'deleteConfirm.dontShowAgain': 'Não mostrar novamente',
  // Settings Panel
  'settings.title': 'Configurações',
  'settings.preferences': 'Preferências',
  'settings.language': 'Idioma',
  'settings.units': 'Unidades',
  'settings.metric': 'Métrico',
  'settings.imperial': 'Imperial',
  'settings.dateFormat': 'Formato de data',
  'settings.timeFormat': 'Formato de hora',
  'settings.logOut': 'Sair',
  'settings.editProfile': 'Editar perfil',
  'settings.fullName': 'Nome completo',
  'settings.profession': 'Profissão',
  'settings.professionPlaceholder': 'ex. Enfermeiro, Cirurgião',
  'settings.emailAddress': 'Endereço de e-mail',
  'settings.emailCannotChange': 'O e-mail não pode ser alterado.',
  'settings.transplantDate': 'Data do transplante',
  'settings.changePassword': 'Alterar senha',
  'settings.deleteAccount': 'Excluir conta',
  'settings.deleteAccountConfirm': 'Tem certeza de que deseja excluir sua conta? Esta ação não pode ser desfeita.',
  'deleteAccount.title': 'Excluir sua conta?',
  'deleteAccount.bullet1': 'Você será desconectado imediatamente e não poderá mais fazer login.',
  'deleteAccount.bullet2': 'Seus registros de saúde, medicamentos e todos os seus dados pessoais serão excluídos permanentemente em até 30 dias.',
  'deleteAccount.bullet3': 'Assinaturas ativas não serão canceladas automaticamente — cancele-as separadamente nas Configurações.',
  'deleteAccount.footer': 'Esta ação não pode ser desfeita.',
  'deleteAccount.confirm': 'Sim, excluir minha conta',
  'deleteAccount.cancel': 'Manter minha conta',
  'settings.cancel': 'Cancelar',
  'settings.saveChanges': 'Salvar alterações',
  // Meds page
  'meds.removeMedication': 'Remover medicamento',
  'meds.removeConfirm': 'Tem certeza de que deseja remover este medicamento?',
  'meds.medCount': 'med.',
  'meds.medsCount': 'meds.',
  'meds.remindersEnabled': 'Lembretes ativados',
  'meds.remindersDisabled': 'Lembretes desativados',
  'meds.addMedication': 'Adicionar medicamento',
  'meds.cancel': 'Cancelar',
  'meds.medicationName': 'Nome do medicamento',
  'meds.medicationNamePlaceholder': 'ex. Tacrolimus',
  'meds.dosage': 'Dosagem',
  'meds.dosagePlaceholder': 'ex. 1',
  'meds.timeslots': 'Horários',
  'meds.addTime': '+ Adicionar horário',
  'meds.type': 'Tipo',
  'meds.shapeCapsule': 'Cápsula',
  'meds.shapeOval': 'Oval',
  'meds.shapeTwoPart': 'Duas partes',
  'meds.shapeDiamond': 'Diamante',
  'meds.shapeRound': 'Redonda',
  'meds.shapeFlat': 'Plana',
  'meds.shapeTriangle': 'Triângulo',
  'meds.pillColour': 'Cor da pílula',
  'meds.customColour': 'Cor personalizada',
  'meds.fillAllFields': 'Por favor preencha todos os campos incluindo pelo menos um horário',
  'meds.edit': 'Editar',
  'meds.delete': 'Excluir',
  'meds.duplicate': 'Duplicar',
  'meds.dropHere': 'Solte aqui para mover',
  'meds.editMedication': 'Editar medicamento',
  'meds.saveChanges': 'Salvar alterações',
  'contacts.edit': 'Editar',
  'contacts.delete': 'Excluir',
  'contacts.editContact': 'Editar contato',
  'contacts.addContact': 'Adicionar contato',
  'contacts.cancel': 'Cancelar',
  'contacts.saveChanges': 'Salvar alterações',
  'contacts.saveContact': 'Salvar contato',
  'contacts.name': 'Nome',
  'contacts.phoneNumber': 'Telefone',
  'contacts.email': 'E-mail',
  'contacts.nephrologist': 'Nefrologista',
  'contacts.pharmacy': 'Farmácia',
  'contacts.emergency': 'Emergência',
  'contacts.other': 'Outro',
  'contacts.nameRequired': 'O nome é obrigatório',
  'contacts.phoneRequired': 'O telefone é obrigatório',
  'contacts.deleteContact': 'Excluir contato',
  'contacts.deleteContactMsg': 'Remover este contato da sua equipe de cuidados?',
  'contacts.addNewContact': 'Adicionar novo contato',
  'contacts.noContacts': 'Nenhum contato adicionado',
  'contacts.addCareTeam': 'Toque no botão acima para adicionar sua equipe',
  'contacts.sortRecent': 'Mais recente',
  'contacts.sortAlpha': 'Alfabética',
  'records.shareCard': 'Compartilhar ficha',
  'records.undoObservation': 'Desfazer observação',
  // Notification settings
  'options.notifications': 'Notificações',
  'options.notificationsAll': 'Todas',
  'options.notificationsLogs': 'Registros',
  'options.notificationsMeds': 'Medicamentos',
  'options.notificationsNone': 'Nenhuma',
  'options.subscription': 'Subscrição',
  'options.subscriptionSubtitle': 'Linha temporal de cobrança e detalhes de renovação.',
  'options.subscriptionPlan': 'Plano',
  'options.subscriptionStatus': 'Estado',
  'options.subscriptionStarted': 'Iniciada em',
  'options.subscriptionNextPayment': 'Próximo pagamento',
  'options.subscriptionExpires': 'Expira em',
  'options.subscriptionNoActive': 'Sem subscrição ativa',
  'options.subscriptionUnavailable': 'Não disponível',
  'account.title': 'Configurações da conta',
  'account.subtitle': 'Revise seu perfil e gerencie suas opções de assinatura.',
  'account.profile': 'Perfil',
  'account.profileSubtitle': 'O teu nome, detalhes do animal e cartão médico',
  'account.profileSaved': 'Perfil salvo.',
  'account.profileSaveError': 'Falha ao salvar o perfil. Tente novamente.',
  'account.savingProfile': 'Salvando…',
  'account.saveProfile': 'Salvar perfil',
  'account.openDashboard': 'Abrir painel',
  'account.starterTrial': 'Starter (Teste)',
  'account.expired': 'Expirada',
  'account.loading': 'Carregando…',
  'account.trialDaysLeft': 'Teste — {days} dia{s} restante{s}',
  'account.expiredDaysLeft': 'Expirada — {days} dia{s} para assinar novamente',
  'account.currentPlan': 'Plano atual',
  'account.fetchingBilling': 'Buscando seus detalhes de cobrança mais recentes.',
  'account.manageSubscription': 'Gerenciar assinatura',
  'account.security': 'Conta e segurança',
  'account.memberSince': 'Membro desde',
  'account.lastLogin': 'Último login',
  'account.passwordResetSent': 'E-mail de redefinição enviado — verifique sua caixa de entrada.',
  'account.resetPassword': 'Redefinir senha',
  'account.resetPasswordEmailError': 'Não foi possível enviar o e-mail de redefinição. Tente novamente.',
  'account.deleteRequiresRecentLogin': 'Por segurança, saia e entre novamente antes de excluir sua conta.',
  'account.deleteFailed': 'Falha ao excluir a conta. Tente novamente.',
  'account.deleting': 'Excluindo…',
  'account.dataPrivacy': 'Dados e privacidade',
  'account.exportDescription': 'Você pode exportar todos os dados vinculados à sua conta em arquivo CSV.',
  'account.preparingExport': 'Preparando exportação…',
  'account.downloadAllData': 'Baixar todos os meus dados',
  'options.notificationSettings': 'Lembretes',
  'options.remindersSubtitle': 'Alertas de medicamentos e notificações push',
  'options.permissions': 'Permissões:',
  'options.activate': 'Ativar:',
  'options.logReminderTimes': 'Horários de lembrete de registros:',
  'options.logReminderTime': 'Hora do lembrete:',
  'options.permissionGrant': 'Conceder permissão',
  'options.browserBlockedHelp': 'As notificações estão bloqueadas pelo seu navegador. Para ativá-las, clique no ícone de cadeado/informações na barra de endereço e permita notificações para este site.',
  'options.appOn': 'App: Ligado',
  'options.appOff': 'App: Desligado',
  'options.browserAllowed': 'Navegador: Permitido',
  'options.browserUnsupported': 'Navegador: Não compatível',
  'options.browserBlocked': 'Navegador: Bloqueado',
  'options.browserNotAsked': 'Navegador: Não solicitado',
  'options.activityTitle': 'Atividade',
  // Lab Glossary
  'guide.labGlossary.intro': 'Compreenda marcadores laboratoriais comuns no acompanhamento pós-transplante. Estas informações são educacionais — sempre discuta seus resultados com sua equipe de transplante.',
  'guide.labGlossary.search': 'Pesquisar marcadores…',
  'guide.labGlossary.all': 'Todos',
  'guide.labGlossary.noMarkersFound': 'Nenhum marcador encontrado.',
  'guide.labGlossary.referenceRange': 'Intervalo de referência típico',
  'guide.labGlossary.note': '⚠️ Nota',
  'guide.labGlossary.marker.creatinine.name': 'Creatinine',
  'guide.labGlossary.marker.creatinine.abbr': 'CREA',
  'guide.labGlossary.marker.creatinine.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.creatinine.why': 'A core kidney marker in dogs and cats. Higher values can suggest reduced kidney filtration, but can also rise with dehydration.',
  'guide.labGlossary.marker.creatinine.typical': 'Dog: ~0.5–1.8 mg/dL · Cat: ~0.8–2.4 mg/dL (lab dependent).',
  'guide.labGlossary.marker.creatinine.note': 'Always interpret with SDMA, BUN, urine concentration, and hydration status.',
  'guide.labGlossary.marker.egfr.name': 'SDMA',
  'guide.labGlossary.marker.egfr.abbr': 'SDMA',
  'guide.labGlossary.marker.egfr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.egfr.why': 'Symmetric dimethylarginine can rise earlier than creatinine and helps detect early kidney changes.',
  'guide.labGlossary.marker.egfr.typical': 'Usually <14 µg/dL in many pet labs.',
  'guide.labGlossary.marker.egfr.note': 'Persistent increases are more meaningful than a one-off value.',
  'guide.labGlossary.marker.bun.name': 'Blood Urea Nitrogen',
  'guide.labGlossary.marker.bun.abbr': 'BUN / Urea',
  'guide.labGlossary.marker.bun.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.bun.why': 'BUN reflects protein waste handling. It can rise with kidney disease, dehydration, GI bleeding, or high-protein diets.',
  'guide.labGlossary.marker.bun.typical': 'Dog: ~7–27 mg/dL · Cat: ~16–36 mg/dL (lab dependent).',
  'guide.labGlossary.marker.tacrolimus.name': 'ALP (Alkaline Phosphatase)',
  'guide.labGlossary.marker.tacrolimus.abbr': 'ALP',
  'guide.labGlossary.marker.tacrolimus.category': 'Liver',
  'guide.labGlossary.marker.tacrolimus.why': 'ALP can increase with liver or bile duct disease, steroid exposure, and growth in young pets.',
  'guide.labGlossary.marker.tacrolimus.typical': 'Often ~20–150 U/L in adult dogs/cats (method dependent).',
  'guide.labGlossary.marker.tacrolimus.note': 'Mild isolated rises can be non-specific; trend and context matter.',
  'guide.labGlossary.marker.ciclosporin.name': 'GGT (Gamma-Glutamyl Transferase)',
  'guide.labGlossary.marker.ciclosporin.abbr': 'GGT',
  'guide.labGlossary.marker.ciclosporin.category': 'Liver',
  'guide.labGlossary.marker.ciclosporin.why': 'GGT helps assess bile flow and hepatobiliary disease, often interpreted alongside ALP and bilirubin.',
  'guide.labGlossary.marker.ciclosporin.typical': 'Often low in healthy pets; reference limits vary by lab.',
  'guide.labGlossary.marker.mmf.name': 'Total Protein',
  'guide.labGlossary.marker.mmf.abbr': 'TP',
  'guide.labGlossary.marker.mmf.category': 'Proteins & Other',
  'guide.labGlossary.marker.mmf.why': 'Total protein combines albumin and globulins and can reflect hydration, inflammation, or protein loss.',
  'guide.labGlossary.marker.mmf.typical': 'Dog: ~5.5–7.5 g/dL · Cat: ~6.0–8.0 g/dL.',
  'guide.labGlossary.marker.potassium.name': 'Potassium',
  'guide.labGlossary.marker.potassium.abbr': 'K+',
  'guide.labGlossary.marker.potassium.category': 'Electrolytes',
  'guide.labGlossary.marker.potassium.why': 'Potassium affects heart and muscle function. Abnormal values may occur with kidney/urinary disease, vomiting, diarrhea, or urinary blockage.',
  'guide.labGlossary.marker.potassium.typical': 'Dog/Cat commonly ~3.5–5.5 mmol/L.',
  'guide.labGlossary.marker.potassium.note': 'Urgent abnormalities can occur with blocked cats and severe dehydration.',
  'guide.labGlossary.marker.sodium.name': 'Sodium',
  'guide.labGlossary.marker.sodium.abbr': 'Na+',
  'guide.labGlossary.marker.sodium.category': 'Electrolytes',
  'guide.labGlossary.marker.sodium.why': 'Sodium reflects fluid balance and can shift with dehydration, endocrine disease, and kidney/urinary issues.',
  'guide.labGlossary.marker.sodium.typical': 'Dog/Cat commonly ~140–160 mmol/L.',
  'guide.labGlossary.marker.bicarbonate.name': 'Chloride',
  'guide.labGlossary.marker.bicarbonate.abbr': 'Cl−',
  'guide.labGlossary.marker.bicarbonate.category': 'Electrolytes',
  'guide.labGlossary.marker.bicarbonate.why': 'Chloride helps acid-base and hydration assessment, especially with sodium and bicarbonate.',
  'guide.labGlossary.marker.bicarbonate.typical': 'Dog/Cat commonly ~105–122 mmol/L.',
  'guide.labGlossary.marker.phosphate.name': 'Phosphorus',
  'guide.labGlossary.marker.phosphate.abbr': 'PHOS',
  'guide.labGlossary.marker.phosphate.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.phosphate.why': 'Phosphorus often rises as kidney disease progresses and is important for CKD staging and nutrition planning.',
  'guide.labGlossary.marker.phosphate.typical': 'Dog: ~2.5–6.0 mg/dL · Cat: ~2.5–6.8 mg/dL.',
  'guide.labGlossary.marker.calcium.name': 'Calcium',
  'guide.labGlossary.marker.calcium.abbr': 'Ca',
  'guide.labGlossary.marker.calcium.category': 'Electrolytes',
  'guide.labGlossary.marker.calcium.why': 'Calcium is important for nerves, muscle, and bones. Values may change with kidney disease, cancer, endocrine disorders, or low albumin.',
  'guide.labGlossary.marker.calcium.typical': 'Total calcium often ~8.5–11.8 mg/dL (species/lab dependent).',
  'guide.labGlossary.marker.haemoglobin.name': 'Red Cell Status',
  'guide.labGlossary.marker.haemoglobin.abbr': 'HGB / HCT / RBC',
  'guide.labGlossary.marker.haemoglobin.category': 'CBC',
  'guide.labGlossary.marker.haemoglobin.why': 'Red cell measurements assess anemia or dehydration. Chronic kidney disease can reduce red blood cell production.',
  'guide.labGlossary.marker.haemoglobin.typical': 'Ranges vary by species and analyzer; use your report\'s HGB/HCT/RBC intervals.',
  'guide.labGlossary.marker.wbc.name': 'White Blood Cell Count',
  'guide.labGlossary.marker.wbc.abbr': 'WBC',
  'guide.labGlossary.marker.wbc.category': 'CBC',
  'guide.labGlossary.marker.wbc.why': 'WBC helps assess inflammation, infection, stress response, and some bone marrow disorders.',
  'guide.labGlossary.marker.wbc.typical': 'Dog roughly ~6–17 ×10⁹/L · Cat ~5–19 ×10⁹/L.',
  'guide.labGlossary.marker.wbc.note': 'Look at differential counts (neutrophils/lymphocytes/eosinophils) for full interpretation.',
  'guide.labGlossary.marker.platelets.name': 'Platelets',
  'guide.labGlossary.marker.platelets.abbr': 'PLT',
  'guide.labGlossary.marker.platelets.category': 'CBC',
  'guide.labGlossary.marker.platelets.why': 'Platelets support blood clotting. Low platelets may increase bleeding risk; false lows can occur from platelet clumping.',
  'guide.labGlossary.marker.platelets.typical': 'Commonly ~200–500 ×10⁹/L (method dependent).',
  'guide.labGlossary.marker.altAst.name': 'ALT / AST',
  'guide.labGlossary.marker.altAst.abbr': 'ALT / AST',
  'guide.labGlossary.marker.altAst.category': 'Liver',
  'guide.labGlossary.marker.altAst.why': 'ALT/AST are liver-associated enzymes. Increases can reflect liver cell injury, inflammation, toxins, or muscle injury (especially AST).',
  'guide.labGlossary.marker.altAst.typical': 'Lab-specific; ALT is usually the more liver-specific value in dogs and cats.',
  'guide.labGlossary.marker.uricAcid.name': 'Albumin',
  'guide.labGlossary.marker.uricAcid.abbr': 'ALB',
  'guide.labGlossary.marker.uricAcid.category': 'Proteins & Other',
  'guide.labGlossary.marker.uricAcid.why': 'Albumin is a key blood protein that can drop with chronic inflammation, protein-losing kidney/gut disease, or liver dysfunction.',
  'guide.labGlossary.marker.uricAcid.typical': 'Dog: ~2.6–4.0 g/dL · Cat: ~2.5–3.9 g/dL.',
  'guide.labGlossary.marker.hba1c.name': 'Glucose',
  'guide.labGlossary.marker.hba1c.abbr': 'GLU',
  'guide.labGlossary.marker.hba1c.category': 'Metabolic',
  'guide.labGlossary.marker.hba1c.why': 'Glucose helps screen for diabetes and stress hyperglycemia (common in cats).',
  'guide.labGlossary.marker.hba1c.typical': 'Dog: ~70–120 mg/dL · Cat: ~70–150 mg/dL.',
  'guide.labGlossary.marker.cmv.name': 'Globulin',
  'guide.labGlossary.marker.cmv.abbr': 'GLOB',
  'guide.labGlossary.marker.cmv.category': 'Proteins & Other',
  'guide.labGlossary.marker.cmv.why': 'Globulins can increase with inflammation/infection and decrease with some immune or protein-losing disorders.',
  'guide.labGlossary.marker.cmv.typical': 'Dog: ~2.0–3.8 g/dL · Cat: ~2.8–5.1 g/dL.',
  'guide.labGlossary.marker.cmv.note': 'Interpret with albumin and total protein (A:G ratio is often useful).',
  'guide.labGlossary.marker.bkv.name': 'Bilirubin',
  'guide.labGlossary.marker.bkv.abbr': 'TBIL',
  'guide.labGlossary.marker.bkv.category': 'Liver',
  'guide.labGlossary.marker.bkv.why': 'Bilirubin can rise with liver disease, bile duct obstruction, or increased red blood cell breakdown.',
  'guide.labGlossary.marker.bkv.typical': 'Usually low/near-zero in healthy pets (lab dependent).',
  'guide.labGlossary.marker.upcr.name': 'Urine Protein:Creatinine Ratio',
  'guide.labGlossary.marker.upcr.abbr': 'UPC / UPCR',
  'guide.labGlossary.marker.upcr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.upcr.why': 'UPC estimates how much protein is lost in urine and helps monitor kidney disease progression and response to treatment.',
  'guide.labGlossary.marker.upcr.typical': 'Dog/Cat: <0.2 non-proteinuric, 0.2–0.5 borderline, >0.5 proteinuric (context matters).',
  'guide.labGlossary.marker.c0d.name': 'Urine Specific Gravity',
  'guide.labGlossary.marker.c0d.abbr': 'USG',
  'guide.labGlossary.marker.c0d.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.c0d.why': 'USG measures urine concentration and is essential for interpreting kidney values and hydration status.',
  'guide.labGlossary.marker.c0d.typical': 'Highly variable; persistently low USG with high kidney markers may indicate kidney dysfunction.',
  'guide.labGlossary.category.kidneyFunction': 'Kidney & Urinary',
  'guide.labGlossary.category.immunosuppressants': 'Chemistry',
  'guide.labGlossary.category.electrolytes': 'Electrolytes',
  'guide.labGlossary.category.bloodCount': 'CBC',
  'guide.labGlossary.category.liverFunction': 'Liver',
  'guide.labGlossary.category.metabolic': 'Metabolic',
  'guide.labGlossary.category.infections': 'Proteins & Other',
  // Register legal
  'register.byRegistering': 'Ao se registrar, você concorda com nossos',
  'register.and': 'e',
  'register.termsOfService': 'Termos de Serviço',
  'register.privacyPolicy': 'Política de Privacidade',
  // CSV headers
  'records.csv.date': 'Data',
  'records.csv.weight': 'Peso',
  'records.csv.fluidIn': 'Líquido Ingerido',
  'records.csv.urineOut': 'Urina',
  'records.csv.amRegistered': 'Manhã Registrada',
  'records.csv.amBP': 'PA Manhã',
  'records.csv.amPulse': 'Pulso Manhã',
  'records.csv.amTemp': 'Temp. Manhã',
  'records.csv.pmRegistered': 'Tarde Registrada',
  'records.csv.pmBP': 'PA Tarde',
  'records.csv.pmPulse': 'Pulso Tarde',
  'records.csv.pmTemp': 'Temp. Tarde',
  'records.csv.observations': 'Observações',
  'records.csv.healthDiary': 'Diário de saúde',
  // Roomies settings
  'options.roomies.description': 'Conecte-se com pacientes pós-transplante do seu grupo. Todas as atividades são anônimas.',
  'options.roomies.nickname': 'Apelido',
  'options.roomies.nicknameMax': '(máx. 12 caracteres)',
  'options.roomies.nicknamePlaceholder': 'ex.: Phoenix',
  'options.roomies.beanColour': 'Cor do BEAN',
  'options.roomies.groupCode': 'Código do grupo',
  'options.roomies.groupCodePlaceholder': 'Insira ou compartilhe seu código de grupo',
  'options.roomies.groupCodeHint': 'Compartilhe este código com seus colegas de hospital para que possam entrar no seu grupo.',
  'options.roomies.enableRoomies': 'Ativar Roomies',
  'options.roomies.enableRoomiesHint': 'Permitir que sua atividade apareça no feed do grupo',
  'options.roomies.noChanges': 'Nenhuma alteração para salvar',
  'options.roomies.saveProfile': 'Salvar perfil Roomie',
  'options.roomies.saved': 'Perfil Roomie salvo!',
  // Companionship (The Koda Fellowship)
  'companions.title': 'Companheirismo',
  'companions.pageTitle': 'A Irmandade Koda',
  'companions.subtitle': 'Veja como o seu pet se compara com companheiros do mundo todo.',
  'companions.publicView': 'Visualização pública',
  'companions.publicViewHint': 'Quando ativada, seu pet aparece no ranking global da Irmandade Koda. Desative para ficar privado — você ainda vê os outros.',
  'companions.publicViewOn': 'Visível no ranking',
  'companions.publicViewOff': 'Oculto no ranking',
  'companions.leaderboardTitle': 'Ranking',
  'companions.leaderboardEmpty': 'Ainda não há companions — seja o primeiro!',
  'companions.leaderboardHint': 'Ordenado por nível e sequência atual. Toque num emoji para incentivar.',
  'companions.you': 'Você',
  'companions.rank': 'Posição',
  'companions.score': 'Pontos',
  'companions.levelShort': 'Nv {n}',
  'companions.streakShort': 'Sequência de {n} dias',
  'companions.hiddenNotice': 'Você está oculto no ranking. Ative a Visualização pública nas Configurações.',
  'companions.tabAll': 'Geral',
  'companions.tabWeek': 'Esta semana',
  'companions.weekXPShort': '+{n} XP esta semana',
  'companions.leaderboardEmptyWeek': 'Sem XP esta semana ainda — registre os sinais e suba no ranking!',
  'companions.leaderboardHintWeek': 'Classificado por XP ganho desde segunda. Reinicia toda semana.',
  'companions.story.title': 'História do companheiro',
  'companions.story.modalTitle': 'Sua história de companheiro',
  'companions.story.hint': 'Escolha um chip e escreva uma nota curta. Ela aparece abaixo da sua linha no ranking.',
  'companions.story.placeholder': 'O que há de novo com seu companheiro?',
  'companions.story.save': 'Salvar história',
  'companions.story.edit': 'Editar história',
  'companions.story.clear': 'Limpar história',
  'companions.story.expiresIn': 'Expira em {n} d',
  'companions.story.recovered': 'Recuperado',
  'companions.story.vaccinated': 'Vacinado',
  'companions.story.grooming': 'Tosa nova',
  'companions.story.vetVisit': 'Visita ao vet',
  'companions.story.newTreat': 'Petisco novo',
  'companions.story.birthday': 'Aniversário!',
  'companions.story.feelingGreat': 'Se sentindo ótimo',
  'companions.story.restingUp': 'Descansando',
  'companions.story.newHome': 'Lar novo',
  // Bean page
  'bean.back': 'Voltar',
  'bean.level': 'Nível',
  'bean.yourBean': 'Seu BEAN',
  'bean.dailyStreak': 'Sequência diária',
  'bean.current': 'Atual',
  'bean.best': 'Melhor',
  'bean.totalXP': 'XP total',
  'bean.streakZero': 'Regista os teus sinais vitais hoje para iniciar a tua sequência!',
  'bean.last30Days': 'Últimos 30 dias',
  'bean.roomies': 'Companheirismo',
  'bean.active': 'Ativo',
  'bean.connectText': 'Conecte-se com tutores de pets pelo mundo. Incentivem-se mutuamente no ranking — anonimamente.',
  'bean.setupRoomies': 'Ative a Visualização pública em Configurações → Companheirismo para aparecer no ranking.',
  'bean.roomiesSettings': 'Configurações de Companion',
  'bean.preview': 'Pré-visualização',
  'bean.noActivity': 'Ainda não há companions — aparecerão aqui conforme fizerem registros.',
  'bean.keepGoing': 'Continue!',
  'bean.justNow': 'agora mesmo',
  'bean.minsAgo': 'há {n}min',
  'bean.hoursAgo': 'há {n}h',
  'bean.daysAgo': 'há {n}d',
  'bean.levelName.seedling': 'Semente',
  'trial.endsToday': 'Seu teste termina hoje — faça upgrade agora para manter seus dados.',
  'trial.endsIn': 'O teste termina em {days} dia{s} — faça upgrade para manter o acesso.',
  'trial.upgrade': 'Fazer upgrade',
  'trial.dismiss': 'Dispensar',
  'layout.offlineBanner': 'Você está offline — as alterações serão sincronizadas quando reconectar',
  'layout.reconnectSyncing': 'De volta online — sincronizando {n} item(ns) pendente(s)…',
  'layout.reconnectSynced': 'Todas as alterações sincronizadas ✓',
  'splash.preparing': 'Preparando tudo para você...',
  'bean.levelName.sprouting': 'Brotando',
  'bean.levelName.budding': 'Brotação',
  'bean.levelName.rooted': 'Enraizado',
  'bean.levelName.thriving': 'Crescendo',
  'bean.levelName.flourishing': 'Florescendo',
  'bean.levelName.resilient': 'Resiliente',
  'bean.levelName.champion': 'Campeão',
  'bean.levelName.guardian': 'Guardião',
  'bean.levelName.legend': 'Lenda',
  'bean.feed.dailyLog': 'registrou seus sinais vitais hoje',
  'bean.feed.dailyLogStreak': 'registrou seus sinais vitais 🔥 sequência de {n} dias',
  'bean.feed.streakMilestone': 'atingiu uma sequência de {n} dias! 🎉',
  'bean.feed.guideArticle': 'leu um artigo do guia',
  'bean.feed.joinedGroup': 'entrou no grupo',
  'bean.feed.changedLook': 'atualizou sua aparência do BEAN 🎨',
  'bean.celebration.levelUpTitle': 'Nível {level}! 🎉',
  'bean.celebration.streakTitle': 'Sequência de {streak} dias! 🔥',
  'bean.celebration.levelUpBody': 'Você alcançou {name}. Continue assim!',
  'bean.celebration.streakBody': '{streak} dias seguidos — consistência incrível!',
  // Notifications
  'notifications.medReminder': 'Lembrete de medicamento',
  'notifications.medReminderBody': 'Hora de tomar: {meds}',
  'notifications.dailyReminder': 'Lembrete de registro diário',
  'notifications.dailyReminderBody': 'Você não registrou nenhum dado hoje. Registrar seus sinais vitais ajuda a acompanhar sua saúde.',
  'notifications.alarmTitle': '💊 Lembrete de medicamento',
  'notifications.alarmBody': 'Hora de tomar {name} ({dosage})',
  // Guide / Library page
  'guide.articles': 'Artigos',
  'guide.subtitle': 'Guias, ferramentas e registros do seu pet.',
  'guide.resources': 'Recursos',
  'guide.minRead': 'min de leitura',
  'guide.unlocksInDay': 'Disponível em {n} dia',
  'guide.unlocksInDays': 'Disponível em {n} dias',
  'guide.category.contacts.title': 'Contatos Médicos',
  'guide.category.contacts.subtitle': 'Tudo em um lugar seguro.',
  'guide.category.medical_card.title': 'Cartão Médico',
  'guide.category.medical_card.subtitle': 'O seu cartão de identidade médica.',
  'guide.category.emergency.title': 'Emergência Veterinária',
  'guide.category.emergency.subtitle': 'Encontre agora o atendimento veterinário mais próximo.',
  'guide.category.how_to.title': 'Como fazer: verificar sinais vitais',
  'guide.category.how_to.subtitle': 'Passo a passo por tipo de animal.',
  'guide.category.hygiene.title': 'Higiene',
  'guide.category.hygiene.subtitle': 'O Novo Normal: Um Guia Moderno de Higiene Pós-Transplante',
  'guide.category.exercise.title': 'Exercício',
  'guide.category.exercise.subtitle': 'O Poder do Movimento: Guia de Exercícios Pós-Transplante',
  'guide.category.wellbeing.title': 'Bem-Estar',
  'guide.category.wellbeing.subtitle': 'Humor, mentalidade e hábitos diários',
  'guide.category.food.title': 'Alimentação',
  'guide.category.food.subtitle': 'Comer bem após o transplante',
  'guide.category.nutrition.title': 'Alimentação',
  'guide.category.nutrition.subtitle': 'Comer bem após o transplante',
  'guide.category.sleep.title': 'Sono',
  'guide.category.sleep.subtitle': 'Descanso e rotina na hora de dormir',
  'guide.category.lab_glossary.title': 'Glossário Lab',
  'guide.category.lab_glossary.subtitle': 'Entender seus resultados',
  'guide.category.vault.title': 'Arquivos Médicos',
  'guide.category.vault.subtitle': 'Carregar, guardar e aceder.',
  'guide.category.reminders.title': 'Lembretes',
  'guide.category.reminders.subtitle': 'Alertas de medicação.',
  'guide.category.co-carers.title': 'Co-Carers',
  'guide.category.co-carers.subtitle': 'Share care with someone else.',
  // Auth — Register
  'register.disclaimerPrefix': 'Entendo que o KodaCare é uma ferramenta de acompanhamento de saúde, não um dispositivo médico, e concordo com a',
  'register.passwordStrength': 'Força:',
  'register.rule.minLength': 'Mínimo 8 caracteres',
  'register.rule.uppercase': 'Letra maiúscula (A–Z)',
  'register.rule.lowercase': 'Letra minúscula (a–z)',
  'register.rule.number': 'Número (0–9)',
  'register.rule.special': 'Carácter especial (!@#$…)',
  'register.strength.veryWeak': 'Muito fraca',
  'register.strength.weak': 'Fraca',
  'register.strength.fair': 'Razoável',
  'register.strength.strong': 'Forte',
  'register.strength.veryStrong': 'Muito forte',
  'register.error.emailInUse': 'Já existe uma conta com este e-mail.',
  'register.error.invalidEmail': 'Por favor, insira um endereço de e-mail válido.',
  'register.error.weakPassword': 'Senha muito fraca. Por favor, escolha uma mais forte.',
  'register.error.network': 'Erro de rede. Verifique a sua ligação e tente novamente.',
  'register.error.generic': 'Registo falhou. Por favor, tente novamente.',
  'register.error.passwordRequirements': 'Por favor, cumpra todos os requisitos da senha.',
  'register.error.passwordsMustMatch': 'As senhas não coincidem.',
  'register.error.googleFailed': 'Início de sessão Google falhou. Por favor, tente novamente.',
  // Auth — Login
  'login.error.incorrectCredentials': 'E-mail ou senha incorretos.',
  'login.error.notVerified': 'O seu endereço de e-mail não foi verificado. Verifique a sua caixa de entrada.',
  'login.error.tooManyRequests': 'Demasiadas tentativas. Por favor, tente novamente mais tarde.',
  'login.error.network': 'Erro de rede. Verifique a sua ligação e tente novamente.',
  'login.error.generic': 'Início de sessão falhou. Por favor, tente novamente.',
  'login.error.googleFailed': 'Início de sessão Google falhou. Por favor, tente novamente.',
  // Medical Card
  'medcard.title': 'Cartão de Identificação Médica',
  'medcard.saveTitleAttr': 'Guardar no perfil',
  'medcard.saved': 'Guardado ✓',
  'medcard.saving': 'A guardar…',
  'medcard.save': 'Guardar',
  'medcard.shareAlt': 'Partilhar como imagem',
  'medcard.shareFailed': 'Falha ao partilhar',
  'medcard.hint': 'Toque num campo para editar · Prima Guardar para sincronizar',
  'medcard.diary.title': 'Diário de saúde',
  'medcard.diary.placeholder': 'Escreva tudo sobre hoje: observações, disposição geral, sinais de boa e má saúde…',
  'medcard.diary.saved': 'Guardado',
  'medcard.diary.saving': 'A guardar…',
  'medcard.fullName': 'Nome do Hooman',
  'medcard.profession': 'Nome do Pet',
  'medcard.dob': 'Raça',
  'medcard.transplantDate': 'Data do Transplante',
  'medcard.hospital': 'Hospital',
  'medcard.processNo': 'Nº de Processo',
  'medcard.surgeon': 'Nefrologista',
  'medcard.allergies': 'Alergias',
  'medcard.avgWeight': 'Peso Méd.',
  'medcard.medications': 'Medicamentos atuais',
  'medcard.avgBP': 'TA Méd.',
  'medcard.placeholder.name': 'Toque para inserir o nome',
  'medcard.placeholder.profession': 'Toque para inserir',
  'medcard.placeholder.dob': 'ex. Pelo curto britânico',
  'medcard.placeholder.hospital': 'Nome do hospital',
  'medcard.placeholder.processNo': 'ex. 123456',
  'medcard.placeholder.surgeon': 'Nome do nefrologista',
  'medcard.placeholder.allergies': 'Nenhuma conhecida',
  // Records — Today's Card
  'records.todaysCard': 'Cartão de Hoje',
  'records.todaysCardComplete': 'Cartão de hoje completo!',
  'records.allThreeLogged': 'Todos os três passos registados — excelente trabalho hoje.',
  'records.filesTooLarge': '{n} ficheiro(s) ignorado(s) com mais de {mb}MB.',
  'records.stepLocked': 'Bloqueado',
  // Trends
  'trends.showLast': 'Mostrar os últimos:',
  // Guide wrappers
  'guide.renderError': 'Erro ao renderizar conteúdo:',
  // AppointmentCalendar
  'appt.kind.checkup': 'Consulta',
  'appt.kind.lab': 'Laboratório',
  'appt.kind.medication': 'Medicação',
  'appt.kind.other': 'Outro',
  'appt.noAppointments': 'Sem consultas neste dia',
  'appt.upcoming': 'Próximos',
  'appt.today': 'Hoje',
  'appt.addEvent': 'Adicionar evento',
  'appt.editEvent': 'Editar evento',
  'appt.titleLabel': 'Título',
  'appt.titlePlaceholder': 'ex. Reforço de vacina',
  'appt.dateLabel': 'Data',
  'appt.timeLabel': 'Hora',
  'appt.kindLabel': 'Tipo',
  'appt.doctorLabel': 'Veterinário',
  'appt.doctorPlaceholder': 'Opcional',
  'appt.locationLabel': 'Local',
  'appt.locationPlaceholder': 'Opcional',
  'appt.save': 'Guardar',
  'appt.cancel': 'Cancelar',
  'appt.delete': 'Eliminar',
  'appt.deleteConfirm': 'Eliminar este evento?',
  // Records share
  'records.weekOf': 'Semana de',
  'records.share.title': 'Resumo diário KodaCare',
  'records.share.weight': 'Peso:',
  'records.share.morning': 'Manhã:',
  'records.share.afternoon': 'Tarde:',
  'records.share.fluidInOut': 'Líquido ingerido: {fluidIn}  |  Urina: {fluidOut}',
  'records.share.note': 'Nota:',
  'records.share.dataTitle': 'Dados de saúde KodaCare',
  'records.share.dataText': 'Os meus dados de saúde do KodaCare - {date}',
  // Notifications accessibility
  'notifications.dismiss': 'Dispensar',
  'notifications.bellLabel': 'Notificações',
  'notifications.settingsLabel': 'Definições de notificação',
  'notifications.fallbackTitle': 'Lembrete KodaCare',
  'fab.voiceHint': 'Quando estiver pronto, diga "Iniciar temporizador Koda"',
  'fab.voicePhrase': 'iniciar temporizador koda',
  'notifications.fallbackBody': 'Tem um novo lembrete.',
  // Vitals redesign stubs
  'records.heartRate': 'Heart Rate',
  'records.respRate': 'Respiratory Rate',
  'records.heartRateRecorded': 'Heart Rate Recorded',
  'records.respRateRecorded': 'Respiratory Rate Recorded',
  'records.temperatureRecorded': 'Temperature Recorded',
  'records.undoHeartRate': 'Undo heart rate',
  'records.undoRespRate': 'Undo respiratory rate',
  'records.undoTemperature': 'Undo temperature',
  'records.wellnessCheck': 'Wellness',
  'records.mucousMembranes': 'Mucous Membranes',
  'records.mm.pink': 'Pink',
  'records.mm.red': 'Red',
  'records.mm.blue': 'Blue',
  'records.mm.white': 'White',
  'records.csv.heartRate': 'Heart Rate (bpm)',
  'records.csv.respRate': 'Resp. Rate (bpm)',
  'records.csv.mucousMembrane': 'Mucous Membrane',
  'records.csv.temp': 'Temp',
  'records.share.fluidIn': 'Fluid In',
  'records.countFor15s': 'Count beats for 15 seconds',
  'records.countBreathsFor15s': 'Count breaths for 15 seconds',
  'records.beats': 'beats',
  'records.breaths': 'breaths',
  'records.saveHeartRate': 'Save Heart Rate',
  'records.saveRespRate': 'Save Respiratory Rate',
  'records.temperature': 'Temperature',
  'records.saveTemperature': 'Save Temperature',
  // Onboarding walkthrough
  'walkthrough.polyName': 'Koda',
  'walkthrough.skip': 'Ignorar',
  'walkthrough.back': 'Voltar',
  'walkthrough.letsGo': 'Vamos lá',
  'walkthrough.next': 'Próximo',
  'walkthrough.finish': 'Concluído! 🎉',
  'walkthrough.step0.title': 'Olá, sou o Koda!',
  'walkthrough.step0.body': 'Prazer em conhecê-lo! Preparei um presente de boas-vindas de +30 XP para si. Mais sobre isso depois… Vou mostrar-lhe tudo.',
  'walkthrough.step1.title': 'Registo diário',
  'walkthrough.step1.body': 'Registe os sinais vitais do seu animal aqui com a maior frequência possível — todos os dias é perfeito.',
  'walkthrough.step2.title': 'Tendências de saúde',
  'walkthrough.step2.body': 'Veja como a saúde do seu animal muda ao longo do tempo com estes gráficos.',
  'walkthrough.step3.title': 'Medicações',
  'walkthrough.step3.body': 'Controle medicações, horários e doses — nunca perca uma dose com lembretes diretamente no seu dispositivo.',
  'walkthrough.step4.title': 'A sua biblioteca de cuidados',
  'walkthrough.step4.body': 'Tudo num só lugar — guias para ganhar XP, o cartão de identificação do seu animal, contactos da equipa de cuidados, registos veterinários e mais. Toque num recurso para começar.',
  'walkthrough.step5.title': 'O seu progresso',
  'walkthrough.step5.body': 'Acompanhe as suas sequências e o progresso de XP, e conheça outros cuidadores nas tabelas de Companheirismo.',
  'options.replayWalkthrough': 'Repetir introdução',
  'members.title': 'Co-cuidadores',
  'members.membersTitle': 'Membros atuais',
  'members.inviteTitle': 'Convidar co-cuidador',
  'members.inviteHint': 'Cria um link de convite seguro e partilha-o diretamente por iMessage, WhatsApp ou qualquer app de mensagens.',
  'members.createLink': 'Criar link de convite',
  'members.copyLink': 'Copiar link',
  'members.copied': 'Copiado!',
  'members.linkCopied': 'Link copiado — partilha-o com o teu co-cuidador.',
  'members.inviteError': 'Não foi possível criar o convite. Tente novamente.',
  'members.pendingTitle': 'Convites pendentes',
  'members.cancelInvite': 'Cancelar',
  'members.owner': 'Proprietário',
  'members.remove': 'Remover acesso',
  'members.confirmRemove': 'Remover {name} como co-cuidador?',
  'members.joinedOn': 'Entrou em',
  'members.sentOn': 'Enviado em',
  'members.loading': 'A carregar…',
  'members.noMembers': 'Ainda sem membros.',
  'members.viewOnlyNotice': 'É co-cuidador deste animal. Só o proprietário pode gerir o acesso.',
  'members.coCarers': 'Co-cuidadores',
  'members.coCarersSubtitle': 'Partilhar os cuidados deste animal com outra pessoa',
  'members.transferTitle': 'Transferir propriedade',
  'members.transferHint': 'Transfere a propriedade total do perfil de {petName} para outro utilizador KodaCare. O destinatário deve ter uma subscrição ativa. Ficarás como co-cuidador após a transferência.',
  'members.transferWarning': 'Esta ação é permanente e irreversível. Perderás os privilégios de proprietário deste animal.',
  'members.transferEmail': 'Endereço de e-mail do destinatário',
  'members.transferSelectCarer': 'Selecionar um co-cuidador existente:',
  'members.transferAction': 'Transferir',
  'members.transferConfirm': 'Transferir a propriedade de {petName} para {email}? Esta ação não pode ser desfeita.',
  'members.transferSuccess': 'Propriedade transferida. Agora és co-cuidador deste animal.',
  'members.transferError': 'Não foi possível transferir a propriedade. Tente novamente.',
  'coCarer.removedNotice.title': 'Foste removido',
  'coCarer.removedNotice.body': 'O proprietário removeu-te como cocuidador de {petName}. O perfil e os dados deste animal deixarão de aparecer na tua conta.',
  'coCarer.removedNotice.ok': 'OK',
  'doses.markAsGiven': 'Marcar como administrado',
  'doses.givenBy': 'Administrado por',
  'doses.at': 'às',
  'doses.alreadyGiven': 'Já administrado',
};